// extracted by mini-css-extract-plugin
export default {"iconButton":"EmailSender_iconButton__SKn04","icon":"EmailSender_icon__0Djwq","icons_label":"EmailSender_icons_label__TaS9C","btnSecond":"EmailSender_btnSecond__6ucr2"};